import { config } from "config";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { redirectToAccounts } from "helpers/routing";
import { IKeyValue, stringifyQueryParams } from "helpers/url";

import { generateErrorMessage } from "./helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IKeyAny<T = any> {
  [key: string]: T;
}

export interface IRequestResult<TResult> {
  result: TResult;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
}

export interface IApiClient {
  updateAccessToken?: (accessToken: string) => void;
  getCurrentAgentId?(): string;
  get: <TResult>(path: string, params?: IKeyValue, headers?: IKeyValue) => Promise<IRequestResult<TResult>>;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  put: <TResult>(path: string, body: any, headers?: IKeyValue) => Promise<IRequestResult<TResult>>;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post: <TResult>(path: string, body: any, headers?: IKeyValue) => Promise<IRequestResult<TResult>>;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch: <TResult>(path: string, body: any, headers?: IKeyValue) => Promise<IRequestResult<TResult>>;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  delete: <TResult>(path: string, body: any, headers?: IKeyValue) => Promise<IRequestResult<TResult>>;
  postWithProgress: <TResult>(
    path: string,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: any,
    headers?: IKeyValue,
    onProgress?: (event: ProgressEvent) => void,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    xhr?: (xhr: XMLHttpRequest, body: any) => void
  ) => Promise<IRequestResult<TResult>>;
}

enum HttpMethod {
  Get = "GET",
  Put = "PUT",
  Post = "POST",
  Patch = "PATCH",
  Delete = "DELETE",
}

interface IRequestOptions {
  path: string;
  method: HttpMethod;
  body?: BodyInit;
  headers?: IKeyValue;
  params?: IKeyValue;
  options?: IKeyValue;
}

export default class ApiClient implements IApiClient {
  static getBaseRootPath(options: IKeyValue): string {
    if (options.video) {
      return `${config.video}/`;
    }

    if (options.globalAccounts) {
      return `${config.globalAccounts}/`;
    }

    if (options.accountsBilling) {
      return `${config.accountsBilling}/`;
    }

    if (options.livechat) {
      return `${config.livechatApi}/`;
    }

    if (options.knowledgebase) {
      return `${config.knowledgebaseApi}/`;
    }

    if (options.devPlatform) {
      return `${config.devPlatformApi}/`;
    }

    return `${config.api}/`;
  }

  private accessToken: string;
  // @ts-expect-error TS(2564): Property 'basicAuthKey' has no initializer and is ... Remove this comment to see the full error message
  private basicAuthKey: string;
  // @ts-expect-error TS(2564): Property 'currentAgentId' has no initializer and i... Remove this comment to see the full error message
  private currentAgentId: string;

  constructor(accessToken: string) {
    this.accessToken = accessToken;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private get authorizationHeaders() {
    const basicAuthHeaders = !this.accessToken ? `Basic ${this.basicAuthKey}` : null;

    return {
      Authorization: this.accessToken ? `Bearer ${this.accessToken}` : basicAuthHeaders,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private getCombinedHeaders(isFormData: boolean) {
    if (isFormData) {
      return { ...this.authorizationHeaders };
    }

    return {
      ...this.authorizationHeaders,
      "Content-Type": "application/json",
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  public updateAccessToken(accessToken: string) {
    if (accessToken !== this.accessToken) {
      this.accessToken = accessToken;
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  public setAuthKey(key: string) {
    if (key !== this.basicAuthKey) {
      this.basicAuthKey = key;
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  public setCurrentAgentId(agentId: string) {
    this.currentAgentId = agentId;
  }

  public getCurrentAgentId(): string {
    return this.currentAgentId;
  }

  public postWithProgress<TResult>(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    path: any,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: any,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    headers: any,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onProgress: any,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    xhrCallback: any
  ): Promise<IRequestResult<TResult>> {
    if (!onProgress) {
      return this.post(path, body, headers);
    }

    const options = { path, body, headers };

    const fullPath = options.path.includes(ApiClient.getBaseRootPath({}))
      ? options.path
      : `${ApiClient.getBaseRootPath({})}${options.path}`;

    const requestResult = {
      result: null,
      error: null,
      responseHeaders: null,
      responseStatus: null,
    };

    return new Promise((resolve, reject) => {
      const isFormData = options.body instanceof FormData;
      const requestHeaders = {
        ...this.getCombinedHeaders(isFormData),
        ...options.headers,
      };

      const xhr = new XMLHttpRequest();
      xhr.open("POST", fullPath, true);
      Object.entries(requestHeaders).forEach(([key, value]) => xhr.setRequestHeader(key, value as string));

      xhr.upload.addEventListener("progress", event => {
        if (!(xhr as XMLHttpRequest & { aborted?: boolean }).aborted) {
          onProgress(event);
        }
      });
      xhr.addEventListener("abort", () => {
        // @ts-expect-error TS(2322): Type '{ error: { message: string; }; }' is not ass... Remove this comment to see the full error message
        requestResult.error = { error: { message: "upload aborted" } };
        // @ts-expect-error TS(2322): Type '0' is not assignable to type 'null'.
        requestResult.responseStatus = 0;
        // @ts-expect-error TS(2345): Argument of type '{ result: null; error: null; res... Remove this comment to see the full error message
        resolve(requestResult);
      });
      xhr.addEventListener("load", () => {
        try {
          // @ts-expect-error TS(2322): Type '{}' is not assignable to type 'null'.
          requestResult.responseHeaders = xhr
            .getAllResponseHeaders()
            .trim()
            .split(/[\r\n]+/)
            .reduce((headersMap, headerEntry) => {
              const [name, ...value] = headerEntry.split(": ");
              const fullValue = value.join(": ");

              return { ...headersMap, [name]: fullValue };
            }, {});
          // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
          requestResult.responseStatus = xhr.status;

          // @ts-expect-error TS(2531): Object is possibly 'null'.
          const contentType = requestResult.responseHeaders["content-type"];
          const isOk = xhr.status < 399 && xhr.status !== 0;

          if (/application\/json/.test(contentType)) {
            const json = JSON.parse(xhr.responseText);
            if (isOk) {
              requestResult.result = json;
            } else {
              if (xhr.status === 401 && json.error !== "insufficient_scope") {
                redirectToAccounts();
              }
              requestResult.error = json;
            }
          } else if (/application\/pdf/.test(contentType)) {
            requestResult.result = xhr.response;
          } else {
            // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'null'.
            requestResult.result = isOk;
          }

          // @ts-expect-error TS(2345): Argument of type '{ result: null; error: null; res... Remove this comment to see the full error message
          resolve(requestResult);
        } catch (error) {
          reject(error);
        }
      });
      xhr.send(isFormData ? options.body : JSON.stringify(options.body));

      if (typeof xhrCallback === "function") {
        xhrCallback(xhr, body);
      }
    });
  }

  private async request<TResult>(options: IRequestOptions): Promise<IRequestResult<TResult>> {
    const additionalOptions = options.options || {};
    let fullPath = options.path.includes(ApiClient.getBaseRootPath(additionalOptions))
      ? options.path
      : `${ApiClient.getBaseRootPath(additionalOptions)}${options.path}`;

    const params = { ...(options.params || {}) };

    if (Object.keys(params).length > 0) {
      fullPath += `?${stringifyQueryParams(params)}`;
    }

    const requestResult = {
      result: null,
      error: null,
      responseHeaders: null,
      responseStatus: null,
    };

    try {
      const isFormData = options.body instanceof FormData;

      const fetchOptions = {
        headers: {
          ...this.getCombinedHeaders(isFormData),
          ...options.headers,
        },
        method: options.method,
        // mode: 'no-cors',
        body: isFormData ? options.body : JSON.stringify(options.body),
      };

      // @ts-expect-error TS(2769): No overload matches this call.
      const response = await fetch(fullPath, fetchOptions);
      const contentType = response.headers.get("Content-Type");

      // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      if (/application\/json/.test(contentType)) {
        const json = await response.json();
        // @ts-expect-error TS(2322): Type 'Headers' is not assignable to type 'null'.
        requestResult.responseHeaders = response.headers;
        // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
        requestResult.responseStatus = response.status;

        if (!response.ok) {
          // eslint-disable-next-line no-console
          console.error(generateErrorMessage(response, json, options.method, fullPath, options.body));

          if (response.status === 401 && json?.error !== "insufficient_scope") {
            // HOTFIX: Due to refresh token problems on LiveChat accounts side it is impossible
            // to recover from livechat/agents endpoint 401 failure.
            // However, we do not want the client to enter the login loop in such case.
            if (!fullPath.includes("integrations/livechat")) {
              redirectToAccounts();
            } else {
              // @ts-expect-error TS(2322): Type '{ error: string; }' is not assignable to typ... Remove this comment to see the full error message
              requestResult.error = { error: "disable_integration" };
            }
          }

          requestResult.error = json;
        } else {
          requestResult.result = json;
        }
        // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      } else if (/application\/pdf/.test(contentType)) {
        const blob = await response.blob();
        // @ts-expect-error TS(2322): Type 'Blob' is not assignable to type 'null'.
        requestResult.result = blob;
      } else {
        // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'null'.
        requestResult.result = response.ok;
      }
    } catch (e) {
      // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'null'.
      requestResult.error = e;
    }

    // @ts-expect-error TS(2339): Property 'error' does not exist on type 'never'.
    if (requestResult.error && requestResult.error.error) {
      const { error } = requestResult.error;

      // Redirect to accounts when accessToken is invalid
      // @ts-expect-error TS(2339): Property 'type' does not exist on type 'never'.
      if (error.type === "auth" && error.message === "Unauthorized") {
        redirectToAccounts();
      }
    }

    // @ts-expect-error TS(2322): Type '{ result: null; error: null; responseHeaders... Remove this comment to see the full error message
    return requestResult;
  }

  async get<TResult>(
    path: string,
    params?: IKeyValue,
    headers?: IKeyValue,
    options?: IKeyValue
  ): Promise<IRequestResult<TResult>> {
    return this.request<TResult>({ path, params, headers, method: HttpMethod.Get, options });
  }

  async post<TResult>(
    path: string,
    body: BodyInit,
    headers?: IKeyValue,
    options?: IKeyValue
  ): Promise<IRequestResult<TResult>> {
    return this.request<TResult>({ path, body, headers, method: HttpMethod.Post, options });
  }

  async put<TResult>(
    path: string,
    body: BodyInit,
    headers?: IKeyValue,
    options?: IKeyValue
  ): Promise<IRequestResult<TResult>> {
    return this.request<TResult>({ path, body, headers, method: HttpMethod.Put, options });
  }

  async patch<TResult>(
    path: string,
    body: BodyInit,
    headers?: IKeyValue,
    options?: IKeyValue
  ): Promise<IRequestResult<TResult>> {
    return this.request<TResult>({ path, body, headers, method: HttpMethod.Patch, options });
  }

  async delete<TResult>(
    path: string,
    body: BodyInit,
    headers?: IKeyValue,
    options?: IKeyValue
  ): Promise<IRequestResult<TResult>> {
    return this.request<TResult>({ path, body, headers, method: HttpMethod.Delete, options });
  }
}
